import axios from 'axios'
import store from '@/store'
import { Indicator, Toast } from 'mint-ui'

const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 5000
})

service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['token'] = 'token'
    }
    Indicator.open({
      text: '加载中',
      spinnerType: 'fading-circle'
    })
    return config
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  // response => {
  //   Indicator.close()
  //   return response
  // },
  response => {
    const res = response.data
    Indicator.close()
    // alert(res.code)
    console.log((res.code !== '200' && res.code !== '4401') || res.info !== 'OK')
    if (res.code === '200' || res.code === '4401' || res.info === 'OK') {
      console.log(response)
      return response.data
    } else {
      Toast({
        message: res.msg,
        iconClass: 'icon icon-error',
        duration: 2000
      })
      if (res.code === 20000) {
      }
      return Promise.reject(response)
    }
  },
  error => {
    console.log(error)
    Indicator.close()
    Toast({
      message: '网络繁忙，请稍后重试',
      duration: 2000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js